/**
 * Created by daniesy on 13/04/2017.
 */
export default class {
    constructor() {
        if (typeof jQuery === 'undefined') { return; }

        $(document).on("keyup", "#form-subscription input[type=email]", function(e) {
            var $input = $(this), $submit = $input.next();
            $submit.attr('disabled', $input.val() === "");
        });

        $(document).on("submit", "#form-subscription", (e) => {
            const $form = $(this),
                $helpBlock = $(".help-block", $form),
                $input = $("input", $form),
                $submit = $("button", $form);

            $submit.html('<i class="fa fa-circle-o-notch fa-spin"></i>');
            $submit.attr('disabled', true);

            $.post($form.attr('action'), $form.serialize(), (response) => {
                $helpBlock.text("You subscription request has been received. Please check your email for further instructions.");
                $form.attr('class', 'has-success');
                $input.val("");
            }).fail((xhr, status, response) => {
                var responseJSON = jQuery.parseJSON(xhr.responseText);
                $helpBlock.text(responseJSON.email[0]);
                $form.addClass('has-error');
            }).always(() => {
                $submit.html('SUBMIT');
                $submit.attr('disabled', false);
            });
            e.preventDefault();
        });
    }
}